module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-infinity-atrium.7610a387.webp";